<template>
  <div>
      <Header></Header>
      <section>
          <div class="bannersecinner">
              <div class="bannersec home">
                  <div class="container">
                      <h2 class="text-center font-weight-bold">404</h2>
                      <p style="text-align: center;display: block">Unknown address, please try again</p>
                  </div>
              </div>
          </div>
      </section>
      <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import {to_top} from "@/helper";


export default {
    components: {
        Header
    },
    mounted() {
        to_top()
    }
}
</script>


